import React, { lazy, Suspense } from 'react';
import { MediaPlayerProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/MediaPlayer/types';

const MediaPlayer = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const MediaPlayerSuspense: React.FC<MediaPlayerProps> = (props) => (
  <Suspense fallback={renderLoader()}>
    <MediaPlayer {...props} />
  </Suspense>
);

export default MediaPlayerSuspense;
